module.exports = __webpack_public_path__ + "img/dance-tiao-icon2.773fda98.png";